//Container for normalized component references to reduce payload size
export class ComponentReferencesV2 {
    Variants: { [key: string]: ComponentVariantReferenceV2 } = {};
    Sizes: { [key: string]: ComponentSizeReferenceV2 } = {};
    Colors: { [key: string]: ComponentColorReferenceV2 } = {};
    Components: { [key: string]: ComponentReferenceV2 } = {};
}

//Reference model for component variants
export class ComponentVariantReferenceV2 {
    Code: string;
    Description: string;
}

//Reference model for component sizes
export class ComponentSizeReferenceV2 {
    Code: string;
    Description: string;
}

//Reference model for component colors
export class ComponentColorReferenceV2 {
    Code: string;
    Description: string;
    GroupCode: string;
    GroupDescription: string;
}

//Reference model for components
export class ComponentReferenceV2 {
    Code: string;
    Description: string;
} 